import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './ceaLookups/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/cea-lookups'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'cea_lookups_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'cea_lookups_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'cea_lookups_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
